import type { IProduct } from './product';

export interface IAddOn extends IProduct {
  name: EAddOns;
  item_id: EAddOnItemIds;
}

export enum EAddOns {
  prepaidMediaBudget = 'Prepaid Media Budget',

  // Only for: Feathr Platform - Essential
  fiveThousandPeople = '+5,000 Additional Known People (Essential)',

  // Only for: Feathr Platform - Advanced
  tenThousandPeople = '+10,000 Additional Known People (Advanced)',
  oneHundredThousandPeople = '+100,000 Additional Known People (Advanced)',
  fiveHundredThousandPeople = '+500,000 Additional Known People (Advanced)',
}

export enum EAddOnItemIds {
  fiveThousandPeople = 'I_110',
  tenThousandPeople = 'I_113',
  oneHundredThousandPeople = 'I_114',
  fiveHundredThousandPeople = 'I_115',
  prepaidMediaBudget = 'I_014',
}

export interface IAddOnCounts {
  fiveThousandPeople: number;
  tenThousandPeople: number;
  oneHundredThousandPeople: number;
  fiveHundredThousandPeople: number;
  prepaidMediaBudget: number;
}

export function getAddOns(serviceIds: EAddOnItemIds[]): IAddOnCounts {
  const itemIdToAddOn: Record<EAddOnItemIds, keyof IAddOnCounts> = {
    [EAddOnItemIds.fiveThousandPeople]: 'fiveThousandPeople',
    [EAddOnItemIds.tenThousandPeople]: 'tenThousandPeople',
    [EAddOnItemIds.oneHundredThousandPeople]: 'oneHundredThousandPeople',
    [EAddOnItemIds.fiveHundredThousandPeople]: 'fiveHundredThousandPeople',
    [EAddOnItemIds.prepaidMediaBudget]: 'prepaidMediaBudget',
  };

  // Initialize counts for all add-ons to 0
  const counts: IAddOnCounts = {
    fiveThousandPeople: 0,
    tenThousandPeople: 0,
    oneHundredThousandPeople: 0,
    fiveHundredThousandPeople: 0,
    prepaidMediaBudget: 0,
  };

  // Count occurrences of each add-on
  serviceIds.forEach((itemId) => {
    const addOn = itemIdToAddOn[itemId];
    if (addOn) {
      counts[addOn]++;
    }
  });

  return counts;
}
